import { call, put } from 'redux-saga/effects';

import actions from '../actions/lists';
import userActions from '../../account/actions';
import { fetchMe } from '../../account/requests';

// Fetch user data again to update the new list name across the app
function* updateUser() {
  try {
    const response = yield call(fetchMe);

    yield put(userActions.userReceive(response.me));
  } catch (error) {
    yield put(actions.renameListError(error));
  }
}

export default updateUser;
